module.exports = __webpack_public_path__ + "img/chain_act.4cfc6d4a.svg";